import type { ReactNode } from "react";

interface SummaryCardSkeleton {
    label: string;
    icon: ReactNode;
    colorClass: "blue" | "green" | "red" | "gray" | "amber";
}

export function SecurityProgressSkeleton({ riskyLabel }: { riskyLabel: string }) {
    return (
        <div className="cs-progress-hero animate-pulse" style={{ margin: 0 }}>
            <div className="cs-progress-details">
                <div className="cs-progress-title-row">
                    <h3 className="cs-progress-main-title">Overall Security Progress</h3>
                    <span className="h-3 w-28 rounded bg-muted/60" />
                </div>

                <div className="cs-bar-wrap">
                    <div className="h-2.5 rounded bg-muted/60" />
                </div>

                <div className="cs-bar-legend">
                    <div className="cs-bar-legend-item">
                        <div className="cs-bar-legend-dot improved" />
                        <span className="h-4 w-6 rounded bg-muted/60" />
                        <span className="cs-bar-legend-label">Risk Reduced</span>
                    </div>
                    <div className="cs-bar-legend-item">
                        <div className="cs-bar-legend-dot worsened" />
                        <span className="h-4 w-6 rounded bg-muted/60" />
                        <span className="cs-bar-legend-label">{riskyLabel}</span>
                    </div>
                    <div className="cs-bar-legend-item">
                        <div className="cs-bar-legend-dot unchanged" />
                        <span className="h-4 w-6 rounded bg-muted/60" />
                        <span className="cs-bar-legend-label">Neutral</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SummaryCardsSkeleton({ cards, className = "" }: { cards: SummaryCardSkeleton[]; className?: string }) {
    return (
        <div className={`cs-hero animate-pulse ${className}`} style={{ margin: 0 }}>
            {cards.map((card) => (
                <div className="cs-hero-card" key={card.label}>
                    <div className={`cs-hero-icon ${card.colorClass}`}>{card.icon}</div>
                    <div className="cs-hero-info">
                        <span className="h-7 w-10 rounded bg-muted/60" />
                        <span className="cs-hero-label">{card.label}</span>
                    </div>
                </div>
            ))}
        </div>
    );
}
